import { CheckCircle2, Sparkles } from 'lucide-react';
import type { AgentMessage } from '../lib/types';

// A question the agent asked with a few clear answers, one button each. Picking one
// sends it as the person's reply; they can also type an answer of their own.
export default function ChatQuestion({ message, answered, onAnswer }: {
    message: AgentMessage;
    /** The person has replied since, so the buttons have done their job. */
    answered: boolean;
    onAnswer: (answer: string) => void;
}) {
    let asked: { options?: string[]; recommended?: string | null } = {};
    try { asked = JSON.parse(message.content); } catch {}
    const options = asked.options ?? [];
    if (options.length === 0) return null;

    return (
        <div className="flex justify-start">
            <div className="max-w-[80%] bg-white border border-softgrey rounded-2xl rounded-bl-none px-3.5 py-3">
                <p className="text-sm text-graphite font-medium">{message.title}</p>
                <div className="mt-2 flex flex-col gap-1.5">
                    {options.map(option => {
                        const recommended = option === asked.recommended;
                        return (
                            <button
                                key={option}
                                type="button"
                                disabled={answered}
                                onClick={() => onAnswer(option)}
                                className={`text-left text-sm rounded-lg border px-3 py-2 transition-colors disabled:cursor-default ${
                                    recommended ? 'border-brand/50 bg-brand/5' : 'border-softgrey'
                                } ${answered ? 'opacity-60' : 'hover:border-brand/60 hover:bg-brand/10'}`}
                            >
                                <span className="text-graphite">{option}</span>
                                {recommended && (
                                    <span className="ml-2 inline-flex items-center gap-1 text-[11px] text-brand-dark">
                                        <Sparkles className="w-3 h-3" aria-hidden /> Recommended
                                    </span>
                                )}
                            </button>
                        );
                    })}
                </div>
                {answered ? (
                    <p className="mt-2 inline-flex items-center gap-1 text-[11px] text-coolslate">
                        <CheckCircle2 className="w-3 h-3" aria-hidden /> Answered
                    </p>
                ) : (
                    <p className="mt-2 text-[11px] text-coolslate">Or type your own answer.</p>
                )}
            </div>
        </div>
    );
}
